import debounce from 'lodash/debounce'

import Component from '../core/Component'
import EventBus from '../core/EventBus'
import withMedia from '../core/withMedia'
import Scroll from '../services/Scroll'

export const STATES = {
    STICKY: 'is-sticky'
}

export const EMITS = {
    END_POSITION: 'end-position',
    START_POSITION: 'start-position',
    STICKING: 'sticking'
}

export class Sticky extends Component {
    constructor(element) {
        super(element, {
            top: 0
        })

        this.isSticky = false

        this.handleResize = debounce(this.handleResize, 200)
    }

    prepare() {
        this.parent = this.element.parentNode

        Scroll.on('scroll', this.handleScroll)
        Scroll.on('resize-x', this.handleResize)
        EventBus.on('tabs:change', this.handleResize)

        this.resize()
        this.render()
    }

    destroy() {
        Scroll.off('scroll', this.handleScroll)
        Scroll.off('resize-x', this.handleResize)
        EventBus.off('tabs:change', this.handleResize)
        this.clear()
    }

    handleScroll = () => {
        this.render()
    }

    handleResize = () => {
        this.resize()
    }

    resize() {
        this.clear()
        this.element.offsetWidth

        const scrollTop = Scroll.getScroll().y

        const parentBox = this.parent.getBoundingClientRect()
        this.parentBox = {
            height: parentBox.height,
            width: parentBox.width,
            top: scrollTop + parentBox.top
        }

        const elementBox = this.element.getBoundingClientRect()
        this.elementBox = {
            height: elementBox.height,
            width: elementBox.width,
            top: scrollTop + elementBox,
            left: elementBox.left
        }

        this.element.style.width = `${this.elementBox.width}px`
    }

    render() {
        if (Scroll.isVirtual) {
            this.renderVirtual()
        } else {
            this.renderNative()
        }
    }

    renderVirtual() {
        const offset = Scroll.getScroll().y - this.parentBox.top + this.options.top
        const max = this.parentBox.height - this.elementBox.height

        if (offset < 0) {
            if (this.isSticky) {
                this.element.classList.remove(STATES.STICKY)
                this.isSticky = false
                this.element.style.transform = 'translateY(0px)'
                this.emit(EMITS.START_POSITION)
            }
        } else if (offset > max) {
            if (this.isSticky) {
                this.element.classList.remove(STATES.STICKY)
                this.isSticky = false
                this.element.style.transform = `translateY(${max}px)`
                this.emit(EMITS.END_POSITION)
            }
        } else {
            if (!this.isSticky) {
                this.element.classList.add(STATES.STICKY)
                this.isSticky = true
                this.emit(EMITS.STICKING)
            }
            this.element.style.transform = `translateY(${offset}px)`
        }
    }

    renderNative() {
        const offset = Scroll.getScroll().y - this.parentBox.top + this.options.top
        const max = Math.max((this.parentBox.height - this.elementBox.height),0)

        if (max === 0) {
            this.clear()
        }

        if (offset < 0) {
            if (this.isSticky) {
                this.element.classList.remove(STATES.STICKY)
                this.isSticky = false
                this.element.style.left = ''
                this.element.style.top = ''
                this.element.style.transform = ``
                this.element.style.position = ''
                this.emit(EMITS.START_POSITION)
            }
        } else if (offset > max) {
            if (this.isSticky) {
                this.element.classList.remove(STATES.STICKY)
                this.isSticky = false
                this.element.style.left = ''
                this.element.style.top = ''
                this.element.style.transform = `translateY(${max}px)`
                this.element.style.position = ''
                this.emit(EMITS.END_POSITION)
            }
        } else {
            if (!this.isSticky) {
                this.element.classList.add(STATES.STICKY)
                this.isSticky = true
                this.element.style.left = `${this.elementBox.left}px`
                this.element.style.top = `${this.options.top}px`
                this.element.style.transform = ``
                this.element.style.position = 'fixed'
                this.emit(EMITS.STICKING)
            }
        }
    }

    clear() {
        this.element.classList.remove(STATES.STICKY)
        this.isSticky = false
        this.element.style.left = ''
        this.element.style.top = ''
        this.element.style.transform = ''
        this.element.style.position = ''
        this.element.style.width = ''
    }
}

export default withMedia(Sticky)
